import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, [
  /*#__PURE__*/_createTextVNode(" 请上传jpg/png的统一尺寸图片，图片比例为1:1，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 推荐尺寸：200px*200px,图片大小不能大于2M ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传jpg/png的统一尺寸图片，图片比例为3:4，推荐尺寸：390px*520px,图片大小不能大于6M ", -1)
const _hoisted_6 = ["src"]

import { reactive, onMounted, ref } from 'vue'
  import api from '@/api/index'
  import { cardApi } from '@/api/card'
  import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
  import {useRouter, useRoute} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Add',
  setup(__props) {

  const router = useRouter()
  const route = useRoute()
  const dialogImageUrl = ref('')
  const dialogVisible = ref(false)
  const baseData:any = reactive({
    loading:false,
    members:[],
    templets:[],
    companys:[],
  })
  const form:any = reactive({
    id: '',
    member_id: '',
    templet_id: '',
    company_id: '',
    img:'',
    name: '',
    position: '',
    phone: '',
    landline: '',
    email: '',
    wxcode: '',
    labels: '',
    address: '',
    introduction: '',
    imglist:[],
    status: '2',
  })
  const getcompanylist = (words:any) =>{
    baseData.loading = true
    api.companyApi.list({page:1,limit:100,words:words}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        let companys:any = []
        if(res.data.list && res.data.list.length>0){
          res.data.list.forEach((item:any) => {
            companys.push({
              value: item.id,
              label: item.title
            })
          })
        }
        
        baseData.companys = companys
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const gettempletlist = (words:any) =>{
    baseData.loading = true
    api.cardApi.templetlist({page:1,limit:100,words:words}).then((res:any)=>{
      if(res.code==200){
        baseData.loading = false
        let templets:any = []
        if(res.data.list && res.data.list.length>0){
          res.data.list.forEach((item:any) => {
            templets.push({
              value: item.id,
              label: item.title
            })
          })
        }
        
        baseData.templets = templets
     }else{
        ElMessage.error(res.message)
     }
    })
  }
  const getmemberlist = (words:any) =>{
    baseData.loading = true
    api.memberApi.list({page:1,limit:100,words:words}).then((res:any)=>{
      if(res.code==200){
        baseData.loading = false
        baseData.members.length = 0
        let members:any = []
        if(res.data.list && res.data.list.length>0){
          res.data.list.forEach((item:any) => {
            members.push({
              value: item.id,
              label: item.nickname
            })
          })
        }
        
        baseData.members = members
     }else{
        ElMessage.error(res.message)
     }
    })
  }
  const uploadImgList = (params:any) => {
    const file = params.file,formData = new FormData();
    if (file.size / 1024 / 1024 > 6) {
        ElMessage.error('banner轮播图超过6MB!')
        return false
    }
    formData.append("file", file)
    api.commonApi.uploadImg(formData).then((res:any)=>{
        if(res.code == 200){
          let data:any = {name:file.name,url:res.data.img}
          form.imglist.pop()
          form.imglist.push(data);
        }
    })
  }
  const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
    console.log(uploadFile, uploadFiles)
  }

  const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
    dialogImageUrl.value = uploadFile.url!
    dialogVisible.value = true
  }
  const onSubmit = () => {
    let data = {...form};
    const loading = ElLoading.service({lock: true})
    data.imglist = form.imglist ? JSON.stringify(form.imglist) : ""
    api.cardApi.add(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/cards");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  const uploadLogo = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('展示图超过2MB!')
        return false
    }
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  onMounted(()=>{
    getmemberlist('')
    gettempletlist('')
    getcompanylist('')
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_ket = _resolveDirective("ket")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/cards' } }, {
              default: _withCtx(() => [
                _createTextVNode("名片列表")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("创建名片")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "姓名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "所属公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.company_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.company_id) = $event)),
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  placeholder: "请输入关键词",
                  "remote-method": getcompanylist,
                  loading: baseData.loading,
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.companys, (item) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])), [
                        [_directive_ket, item.value]
                      ])
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "拥有者" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.member_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.member_id) = $event)),
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  placeholder: "请输入关键词",
                  "remote-method": getmemberlist,
                  loading: baseData.loading,
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.members, (item) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])), [
                        [_directive_ket, item.value]
                      ])
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "名片样式" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.templet_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.templet_id) = $event)),
                  filterable: "",
                  remote: "",
                  "reserve-keyword": "",
                  placeholder: "请输入关键词",
                  "remote-method": gettempletlist,
                  loading: baseData.loading,
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.templets, (item) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])), [
                        [_directive_ket, item.value]
                      ])
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form, {
              model: form,
              inline: true,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "展示图" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { class: "martop" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          action: "",
                          "http-request": uploadLogo,
                          "show-file-list": false
                        }, {
                          tip: _withCtx(() => [
                            _hoisted_4
                          ]),
                          default: _withCtx(() => [
                            (form.img)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: form.img,
                                  class: "avatar"
                                }, null, 8, _hoisted_3))
                              : (_openBlock(), _createBlock(_component_el_icon, {
                                  key: 1,
                                  class: "avatar-uploader-icon"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_el_form, {
              model: form,
              inline: true,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "职位" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.position,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.position) = $event)),
                      maxlength: "150",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "公司电话" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.phone,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.phone) = $event)),
                      maxlength: "150",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "座机" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.landline,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.landline) = $event)),
                      maxlength: "150",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "邮箱" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.email,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.email) = $event)),
                      maxlength: "150",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "微信号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.wxcode,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.wxcode) = $event)),
                      maxlength: "150",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "标签",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.labels,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.labels) = $event)),
                      maxlength: "250",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "地址",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.address,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.address) = $event)),
                      maxlength: "250",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "简介",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.introduction,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.introduction) = $event)),
                      maxlength: "350",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "展示图" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      "file-list": form.imglist,
                      "onUpdate:fileList": _cache[12] || (_cache[12] = ($event: any) => ((form.imglist) = $event)),
                      action: "",
                      "http-request": uploadImgList,
                      "list-type": "picture-card",
                      "on-preview": handlePictureCardPreview,
                      "on-remove": handleRemove
                    }, {
                      tip: _withCtx(() => [
                        _hoisted_5
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["file-list"]),
                    _createVNode(_component_el_dialog, {
                      modelValue: dialogVisible.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogVisible).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          "w-full": "",
                          src: dialogImageUrl.value,
                          alt: "Preview Image"
                        }, null, 8, _hoisted_6)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("冻结")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("待绑定")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: goBack }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})